module.exports = __webpack_public_path__ + "static/media/animated-loading-ooredoops.701626df.gif";